<bs-digital-quick-bet-container
    class="quick-bet-module reward-tokens-module betslip-vars-scope"
    *ngIf="oddsDisplayFormat$ | async as oddsDisplayFormat"
    [oddsDisplayFormat]="oddsDisplayFormat"></bs-digital-quick-bet-container>
